import React from "react";
import ForgotPassword from "../components/ForgotPassword";

const forgotpassword = () => {
  return <ForgotPassword />;
};

export default forgotpassword;
